var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "config" } },
    [
      _vm._l(_vm.env, function (item) {
        return _c(
          "div",
          { key: item, staticClass: "env" },
          [
            item === _vm.config.env
              ? [
                  _c("Icon", {
                    attrs: { type: "md-checkmark-circle-outline", size: "16" },
                  }),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.name[item]) + " environment"),
                  ]),
                  _c("p", [
                    _vm._v("baseAPI: " + _vm._s(_vm.config.baseAPI[item])),
                  ]),
                ]
              : [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleChange(item)
                        },
                      },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.name[item]) + " environment"),
                      ]),
                    ]
                  ),
                ],
          ],
          2
        )
      }),
      _c(
        "Form",
        {
          ref: "config",
          attrs: { model: _vm.config },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.handleSave.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "FormItem",
            [
              _c("Input", {
                attrs: {
                  placeholder: "You can enter new API",
                  prefix: "md-link",
                },
                model: {
                  value: _vm.config.newBaseAPI,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "newBaseAPI", $$v)
                  },
                  expression: "config.newBaseAPI",
                },
              }),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { long: "", type: "primary" },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "Button",
                    { attrs: { long: "" }, on: { click: _vm.handleReset } },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }